import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../services/auth.services';
import { Component, Output, EventEmitter } from '@angular/core';
import { Globals } from 'app/globals/globals';

@Component({
  selector: 'app-header-left-sidebar',
  templateUrl: './app-header-left-sidebar.component.html'
})
export class AppHeaderLeftSidebarComponent {
  userName: string;
  myClass: string;
  mMenus: any =[];
  mMenusType: any =[];
  constructor(
    private auth: AuthService,
    private translate: TranslateService,
    private global: Globals
  ) {
    this.userName = this.global.getCookie('sidebar').fullName;
    this.myClass = 'flag-icon flag-icon-' + window.localStorage.getItem('tokenLanguage');
  }
  logout() {
    this.auth.logout();
  }
  menuChange() {
  }
  changeLanguage(lang) {
    this.myClass = 'flag-icon flag-icon-' + lang;
    this.translate.use(lang);
    window.localStorage.setItem(
      'tokenLanguage', lang
    );
      /*
    this.mMenus = this.global.getCookie('sidebar');
    this.mMenusType = [];
    if (lang === 'th'){
      this.mMenus.menus.forEach(p =>
        this.mMenusType.push({
              checked: p.checked,
              childs: p.childs,
              menuIcon: p.menuIcon,
              menuID: p.menuID,
              menuImage: p.menuImage,
              menuSortIndex: p.menuSortIndex,
              menuSubSystemID: p.menuSubSystemID,
              menuSystemName: p.menuSystemNameTH,
              menuSystemNameTmp: p.menuSystemName,
              menuSystemUrl: p.menuSystemUrl,
              useFlag: p.useFlag
        })

      )
      this.mMenus.menus = this.mMenusType;
    } else {
      this.mMenus.menus.forEach(p =>
        this.mMenusType.push({
              checked: p.checked,
              childs: p.childs,
              menuIcon: p.menuIcon,
              menuID: p.menuID,
              menuImage: p.menuImage,
              menuSortIndex: p.menuSortIndex,
              menuSubSystemID: p.menuSubSystemID,
              menuSystemName: p.menuSystemName,
              menuSystemNameTmp: p.menuSystemNameTH,
              menuSystemUrl: p.menuSystemUrl,
              useFlag: p.useFlag
        })

      )
      this.mMenus.menus = this.mMenusType;
    }
    this.global.menuList = this.mMenusType;
    this.global.setCookie('sidebar', this.mMenus);
    */
  }
}



// WEBPACK FOOTER //
// ./src/app/components/app-header-left-sidebar/app-header-left-sidebar.component.ts